import axios from "axios";
import qs from "qs";
import Bus from './Bus';

var instance = axios.create({
  baseURL: "/api_b",
  timeout: 3*60*1000,
  headers: {
    "X-Custom-Header": "foobar",
    "Content-Type": "application/json",
    // "Content-Type": "multipart/form-data",
  }
});
// Add a request interceptor
instance.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    console.log(config, "sfdsdf");
    if (
      config.method.toLowerCase() === "post" &&
      config.data &&
      config.data.formEncode
    ) {
      config.data = qs.stringify(config.data);
    }

    
    Bus.$emit('show-loading')
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

const codeMessage = {
  200: "服务器成功返回请求的数据。",
  201: "新建或修改数据成功。",
  202: "一个请求已经进入后台排队（异步任务）。",
  204: "删除数据成功。",
  400: "发出的请求有错误，服务器没有进行新建或修改数据的操作。",
  401: "用户没有权限（令牌、用户名、密码错误）。",
  403: "用户得到授权，但是访问是被禁止的。",
  404: "发出的请求针对的是不存在的记录，服务器没有进行操作。",
  406: "请求的格式不可得。",
  410: "请求的资源被永久删除，且不会再得到的。",
  422: "当创建一个对象时，发生一个验证错误。",
  500: "服务器发生错误，请检查服务器。",
  502: "网关错误。",
  503: "服务不可用，服务器暂时过载或维护。",
  504: "网关超时。"
};

const errorHandler = error => {
  const {
    response = {}
  } = error;
  const errortext = codeMessage[response.status] || response.statusText;
  const {
    status,
    url
  } = response;
  if (status === 401) {
    window.notification.error({
      message: "未登录或登录已过期，请重新登录。"
    });
    return;
  }
  // if (error.response) {
  //   // 请求已发出，但服务器响应的状态码不在 2xx 范围内
  //   console.log(error.response.data);
  //   console.log(error.response.status);
  //   console.log(error.response.headers);
  // } else {
  //   // Something happened in setting up the request that triggered an Error
  //   console.log('Error', error.message);
  // }
  // console.log(error.config);
  if (!status) {
    return;
  }
  window.notification.error({
    message: `请求错误 ${status}: ${error.config.url}`,
    description: errortext
  });
  // environment should not be used
  if (status === 403) {
    // router.push('/exception/403');
    return;
  }
  if (status <= 504 && status >= 500) {
    // router.push('/exception/500');
    return;
  }
  if (status >= 404 && status < 422) {
    // router.push('/exception/404');
  }
};
const _hideLoading = function () {
  Bus.$emit('hide-loading')
};
// Add a response interceptor
instance.interceptors.response.use(
  function (response) {
    // Do something with response data
    const {
      code,
      msg
    } = response.data;
    console.log(response,"->response")
    _hideLoading();
    if (code !== 200) {
     
      
    if(response.config.url.indexOf("/queryProvinces")>-1){
      return response;
    }
    
    window.message.error(msg);

      
      return Promise.reject(response);
    }

    return response;
  },
  function (error) {
    _hideLoading()
    if (error.response) {
      // 请求已发出，但服务器响应的状态码不在 2xx 范围内
      errorHandler(error);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log("Error", error.message);
      window.message.error(error.message);
    }
    // Do something with response error
    return Promise.reject(error);
  }
);

let api = {};
//保存/更新
api.saveOrUpdate = function (data) {
    return instance.post('/quote/saveOrUpdate', data);
};

//省查询
api.queryProvinces= function (data) {
    return instance.post('/pageButtController/queryProvinces', data);
};

//查询模板下的所有信息
api.queryQuotationInfo= function (data) {
    return instance.post('/quote/queryQuotationInfo', data);
};

//计算保费
api.calculatePremium= function (data) {
    return instance.post('/quote/calculatePremium', data);
};

//获取页面配置
api.getPageConfig= function (data) {
    return instance.post(`quote/getPageConfig?${qs.stringify(data)}`);
};

//查询模板列表
api.fetchList= function (data) {
    return instance.post('/quote/queryQuotationList', data);
};

//删除模板
api.delete= function (data) {
    return instance.post('/quote/delete', data);
};

// 报价书数据保存/查询接口
api.quotationLinkData= function (data) {
    return instance.post('/quote/quotationLinkData', data);
};
export default api;